import axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios';
import { API_KEY_VALUES } from 'config/constants/api.constants';
import { isAuthError } from 'config/utils/errors.util';
import AuthIntentUtils from 'config/utils/auth-intent.util';
import CartUtils from 'config/utils/cart.util';
import NavigationUtils from 'config/utils/navigation.util';
import { AuthSlice } from 'store/slices/auth.slice';
import { store } from '../../../store';
import { UserSlice } from 'store/slices/user.slice';

export const AxiosInterceptor = () => {
  axios.interceptors.request.use(
    (request: InternalAxiosRequestConfig) => {
      const storeState = store.getState();
      const { accessToken } = storeState.auth;
      request.headers['x-country'] = API_KEY_VALUES.COUNTRY_KEY ?? '';
      request.headers['x-client-key'] = API_KEY_VALUES.CLIENT ?? '';
      request.headers['Content-Type'] = 'application/json';

      if (accessToken) {
        request.headers.Authorization = `Bearer ${accessToken}`;
      }

      return request;
    },
    (error) => Promise.reject(error),
  );

  axios.interceptors.response.use(
    (response: AxiosResponse) => {
      const { data } = response;
      return data;
    },
    (error: unknown) => {
      if (isAuthError(error)) {
        const { isAuthenticated, sessionExpired } = store.getState().auth;
        if (sessionExpired) return Promise.reject(error);

        if (isAuthenticated) {
          store.dispatch(AuthSlice.invalidateSession());
          store.dispatch(UserSlice.resetUserStore());
          CartUtils.handleAuthInvalidated();
          AuthIntentUtils.requireAuth({
            redirectTo: NavigationUtils.getLocationRedirectPath(window.location.pathname, window.location.search),
          });
        } else {
          store.dispatch(AuthSlice.resetAuhStore());
          store.dispatch(UserSlice.resetUserStore());
          CartUtils.handleAuthInvalidated();
        }

        return Promise.reject(error);
      }

      return Promise.reject(error);
    },
  );
};
